import { Model, Attr, PersistedSpraypaintRecord } from 'spraypaint';
import { ApplicationRecord, User } from 'spa-ionata-admin/lib/models';

export type PersistedUser = PersistedSpraypaintRecord<UserExt>;

@Model()
export default class UserExt extends User {
  static jsonapiType = User.jsonapiType;

  @Attr() isActive!: boolean;
}

// A hacky way to override the already registered factory
(ApplicationRecord.typeRegistry as HashAny)['_typeMap'][User.jsonapiType] =
  UserExt;
